import Key from "csi/core/Key";
import SpecBuilder from "csi/core/SpecBuilder";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import Container from "csi/heading/Container";
import CustomViewAttributesStore from "csi/middleware/customView/attributes/CustomViewAttributesStore";
import { CustomViewMigrationKeyReport, createRemoveItem, validateCustomViewKeys } from "csi/middleware/customView/customViewValidateService";
import localeProvider from "csi/page/localeProvider";
import declare from "dojo/_base/declare";
import { each, groupBy } from "lodash";
import { C8AttributeKey } from "src/c8-platform/type/value";
import { CustomViewTable } from "../CustomView/Table";

const Errors = declare(Container, {
	type: "stringlist",

	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement, actionData: ActionData): boolean {
		// summary: render errors in custom view
		const thisView = ctx.view as CustomViewTable;
		const fullReport = new CustomViewMigrationKeyReport();
		const dsp = ctx.getNode();
		const keys: C8AttributeKey[] = Object.values(dsp.Keys);
		const keysByType = groupBy(keys, (key) => {
			const { extendedPath } = new Key({ dpkey: key }, true);
			return extendedPath?.startClass?.type || "";
		});
		const attributesOptions = {
			noGroupSupport: true,
			noMatrixSupport: true,
			noVisibilitySupport: true,
			omitReferencedImages: true,
			useNamePropInPlaceOfNodeNameAttr: true,
		};

		each(keysByType, (keys, type) => {
			const report = new CustomViewMigrationKeyReport();

			if (type) {
				const attributesStore = new CustomViewAttributesStore(localeProvider, attributesOptions);
				const specBuilder = new SpecBuilder(type);
				attributesStore.addLevel({ specBuilder });
			
				validateCustomViewKeys(report, keys, attributesStore);
			} else {
				const items = keys.map((key) => createRemoveItem(key));
				report.addSection("Untyped keys", items);
			}

			fullReport.addReport(report);
		});
		
		thisView.addReport("DataSheetPage", fullReport);

		return thisView.renderReport(refNode, fullReport);
	},
});

export = Errors;
